import axios from 'axios'

export default {
  getVips(params) {
    return axios.get(`/hotspots/vip-devices/${params}`)
  },
  getBlockeds(params) {
    return axios.get(`/hotspots/blocked-users/${params}`)
  },
  blockUser(payload) {
    //console.log(JSON.stringify(payload,null,2))
    return axios.post(`/hotspots/block-user/`, payload)
  },
  vipDevice(payload) {
    //console.log(JSON.stringify(payload,null,2))
    return axios.post('/hotspots/vip-device/', payload)
  }
}
